import React from 'react';
import { SparklesIcon, TruckIcon, GiftIcon, PercentIcon, AwardIcon, QuoteIcon, ChevronRight } from 'lucide-react';
export function WineClubSection() {
  return <section className="bg-white py-20 px-8 relative overflow-hidden" data-id="element-476">
      {/* Bubble Background with Pink Gradient Overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-20 z-0" style={{
      backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/bubbles-scaled.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-477" />
      <div className="absolute inset-0 bg-gradient-to-b from-pink-50/30 to-transparent pointer-events-none z-0" data-id="element-478" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-479">
        <div className="text-center mb-12" data-id="element-480">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-481" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-482">
            Membership
          </div>
          <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-483">
            Wine Club
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-484">
            Join our exclusive wine club and enjoy regular shipments of our
            finest wines, member-only events, and special discounts.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-485">
          {/* Premium Club */}
          <div className="border border-neutral-400 rounded-none p-8 flex flex-col bg-white shadow-lg" data-id="element-486">
            <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-4 text-center" data-id="element-487">
              The Pink Club
            </h3>
            <p className="text-base text-neutral-600 mb-6 leading-relaxed text-left flex-1" data-id="element-488">
              The Pink Club is perfect for lovers of sweeter bubbles, featuring
              our famous Pink Blush and more. Enjoy three deliveries of six
              bottles in April, August, and November — choose our curated
              selection or create your own custom pack.
            </p>
            <div className="space-y-3 mb-8" data-id="element-489">
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-490">
                <TruckIcon className="w-5 h-5 text-brand-pink" data-id="element-491" />
                <span className="text-sm" data-id="element-492">3 deliveries per year</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-493">
                <GiftIcon className="w-5 h-5 text-brand-pink" data-id="element-494" />
                <span className="text-sm" data-id="element-495">6 bottles per delivery</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-496">
                <PercentIcon className="w-5 h-5 text-brand-pink" data-id="element-497" />
                <span className="text-sm" data-id="element-498">Exclusive member discounts</span>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-499">
              <button className="bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium inline-flex items-center justify-center gap-2 rounded-none group" data-id="element-500">
                Join Pink
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-501" />
              </button>
            </div>
          </div>
          {/* Classic Club */}
          <div className="border border-neutral-400 rounded-none p-8 flex flex-col bg-white shadow-lg" data-id="element-502">
            <h3 className="font-heading text-2xl font-normal text-neutral-900 mb-4 text-center" data-id="element-503">
              The Premium Club
            </h3>
            <p className="text-base text-neutral-600 mb-6 leading-relaxed text-left flex-1" data-id="element-504">
              The Premium Club is for those who love drier, traditional méthode
              sparkling wines. Receive three deliveries of four bottles in
              March, June, and October — featuring our newest releases,
              handpicked by the winemaker before public release.
            </p>
            <div className="space-y-3 mb-8" data-id="element-505">
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-506">
                <TruckIcon className="w-5 h-5 text-neutral-500" data-id="element-507" />
                <span className="text-sm" data-id="element-508">3 deliveries per year</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-509">
                <AwardIcon className="w-5 h-5 text-neutral-500" data-id="element-510" />
                <span className="text-sm" data-id="element-511">Winemaker selections</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-600" data-id="element-512">
                <PercentIcon className="w-5 h-5 text-neutral-500" data-id="element-513" />
                <span className="text-sm" data-id="element-514">Priority access to releases</span>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-515">
              <button className="bg-brand-grey text-white px-8 py-4 hover:bg-neutral-700 transition-colors font-medium inline-flex items-center justify-center gap-2 rounded-none group" data-id="element-516">
                Join Premium
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-517" />
              </button>
            </div>
          </div>
        </div>
        {/* Customer Review */}
        <div className="mt-16 max-w-3xl mx-auto" data-id="element-518">
          <div className="bg-white border border-neutral-400 rounded-none p-8 md:p-12 shadow-lg" data-id="element-519">
            <div className="flex justify-center mb-6" data-id="element-520">
              <QuoteIcon className="w-12 h-12 text-brand-pink opacity-20" data-id="element-521" />
            </div>
            <blockquote className="text-center" data-id="element-522">
              <p className="text-base text-neutral-700 mb-6 leading-relaxed italic" data-id="element-523">
                Joining the Pink Club has been one of the best decisions we've
                made. Every delivery feels like a celebration, and the quality
                of the sparkling wines is exceptional.
              </p>
              <footer className="text-center" data-id="element-524">
                <p className="text-sm font-medium text-neutral-900" data-id="element-525">
                  Sarah Mitchell
                </p>
                <p className="text-xs text-neutral-500" data-id="element-526">
                  Pink Club Member since 2022
                </p>
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}